import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {configureApi} from './api/configureApi';
import {initSentry} from './sentry';

// Before configureApi and before the first render, so an error thrown during either is still
// captured. No-ops until a DSN is set.
initSentry();

// Wire the OpenAPI-generated client (base URL + auth/timezone interceptor) once, before
// any render or SDK call. Idempotent — mirrors how the mobile app configures its client.
configureApi();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
